import {useQuery} from '@tanstack/react-query';

import apiService from '../../transport/apiService';
import {logger} from '../../utils/logger';

/**
 * Cache key shape: ['segments', 'feed', 'v1', storeNumber, storeState].
 *
 * Re-activated as part of DIS-1306. The endpoint was previously called by
 * `feedStore.getSegments` but became a no-op when client-side derivation
 * from `allItems` replaced it. With segment-scoped pagination, the client
 * no longer has the full universe; the server endpoint is again the source
 * of truth for the tab strip.
 */
export const feedSegmentsQueryKey = (storeNumber?: string, storeState?: string) =>
  ['segments', 'feed', 'v1', storeNumber, storeState] as const;

export const feedSegmentsQueryFn = async (
  storeNumber: string,
  storeState: string,
): Promise<string[]> => {
  const data = (await apiService.getSegments(storeNumber, storeState)) ?? [];
  logger.info('useFeedSegments', 'Segments loaded', {count: data.length});
  return data;
};

export const useFeedSegments = ({
  storeNumber,
  storeState,
}: {
  storeNumber?: string;
  storeState?: string;
}) =>
  useQuery<string[]>({
    queryKey: feedSegmentsQueryKey(storeNumber, storeState),
    queryFn: () => feedSegmentsQueryFn(storeNumber as string, storeState as string),
    enabled: !!storeNumber && !!storeState,
  });
